import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { TaxModuleType } from './types.ts'

interface EditProps {
  tax_module: TaxModuleType
}

export default function Edit({ tax_module }: EditProps) {
  return (
    <>
      <Head title="Editing tax module" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing tax module</h1>

        <Form
          tax_module={tax_module}
          action={`/admin/tax_modules/${tax_module.id}`}
          method="patch"
          submitText="Mettre à jour le module fiscal"
        />

        <Link
          href={`/admin/tax_modules/${tax_module.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Voir ce module fiscal
        </Link>
        <Link
          href="/admin/tax_modules"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux modules fiscaux
        </Link>
      </div>
    </>
  )
}
